import styled from "styled-components";

export default styled.div`
   ${props => props.theme.media.xxl} {
    .blog-container { max-width: 1219px; } 
   }
   .tax-tips {
     padding-bottom: 15px;
     ${props => props.theme.media.lg} {
       padding-bottom: 0;
     }
    h2 {
      font-size: 30px;
      font-weight: 500;
      margin-bottom: 0.5rem;
      text-align: center;
      margin-bottom: 15px;
    }

    .section-subtitle {
      margin-bottom: 0.3rem;
      text-align: center;
      font-size: 18px;
      line-height: 1.3;
      font-weight:400;
    }

    ${props => props.theme.media.md} {
      h2 {
        color: #505050;
        font-size: 40px;
        margin-bottom: 40px;
      }
    }

    .products-wrapper {
      .product {
        margin-bottom: .5rem;
        padding: 0;
        text-align: center;

        ${props => props.theme.media.md} {
          margin-bottom: 0;
          padding: 0 30px;
        }

        .image, .product-title {
          cursor: pointer;
        }
        .image img {
            margin: auto;
            display: block;
            max-height: 167px;
        }

        .copy {
          padding: 0 15px;
          width: 350px;
          max-width: 100%;
          margin auto;
          padding: 0;
          

          .product-title {
            min-height: 52px;
            font-size: 22px;
            font-weight: 600;
            line-height: 1.3;
            margin: 1rem 0 0.5rem 0;
            color: #505050 !important;
            ${props => props.theme.media.md} {
             text-align: left;
            }
          }

           a {
            ${props => props.theme.media.md}{
              text-align: right;
              &::after {
                content: ' >'
              }
            }
           }
          .product-description {
            font-size: 16px;
            line-height: 1.2;
            margin: 0 auto;
            min-height: 70px;
            font-weight: 300;
            ${props => props.theme.media.md} {
              text-align: left;
              min-height: 240px;
             }
          }

          .text-center {
            color: #FD5700;
            display: block;
            margin: 1rem 0;
          }

          ${props => props.theme.media.md} {

            .product-title {
              font-size: 19px;
            }
            .product-description {
              font-size: 16px;
              line-height: 1.5;
            }
  
          }
        }
      }
    }
  }
`;
